import { axiosClient } from 'shared/lib/axios'

/**
 * Retrieves the user's profile details.
 *
 * @returns {Promise} A promise that resolves with the server's response.
 */
export const getUserDetail = () => {
  return axiosClient.get('/admin/get/v1')
}

export const editProfile = (data) => {
  return axiosClient.put('/admin/update-profile/v1', data)
}

// export const LoginMutation = ({ sLogin, sPassword }) => {
//   return axiosClient.post('/admin/auth/login/v1', { sLogin, sPassword })
// }
